import { contentTypes } from '../types';

export type BulkUploadType = Exclude<contentTypes.ContentType, 'text'>;

type MediaConfig = {
  type: BulkUploadType;
  title: string;
  formatsHint: string;
  accept: string;
  extensions: string[];
  allowedLabel: string;
};

const PHOTO_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'heic'];
const VIDEO_EXTENSIONS = ['mp4', 'mov'];
const AUDIO_EXTENSIONS = ['mp3', 'm4a', 'ogg', 'wav'];
const DOCUMENT_EXTENSIONS = ['pdf'];

export const BULK_UPLOAD_TYPES: BulkUploadType[] = ['photo', 'video', 'audio', 'document'];

export const isBulkUploadType = (value: string | undefined): value is BulkUploadType =>
  !!value && BULK_UPLOAD_TYPES.includes(value as BulkUploadType);

export const MEDIA_CONFIG: Record<BulkUploadType, MediaConfig> = {
  photo: {
    type: 'photo',
    title: 'фото',
    formatsHint: 'JPG, PNG, WEBP, HEIC',
    accept: 'image/jpeg,image/png,image/webp,image/heic,.heic',
    extensions: PHOTO_EXTENSIONS,
    allowedLabel: 'JPG, JPEG, PNG, WEBP, HEIC',
  },
  video: {
    type: 'video',
    title: 'видео',
    formatsHint: 'MP4, MOV',
    accept: 'video/mp4,video/quicktime,.mov,.mp4',
    extensions: VIDEO_EXTENSIONS,
    allowedLabel: 'MP4, MOV',
  },
  audio: {
    type: 'audio',
    title: 'аудио',
    formatsHint: 'MP3, M4A, OGG, WAV',
    accept: 'audio/mpeg,audio/mp4,audio/ogg,audio/wav,.mp3,.m4a,.ogg,.wav',
    extensions: AUDIO_EXTENSIONS,
    allowedLabel: 'MP3, M4A, OGG, WAV',
  },
  document: {
    type: 'document',
    title: 'документы',
    formatsHint: 'PDF',
    accept: '.pdf,application/pdf',
    extensions: DOCUMENT_EXTENSIONS,
    allowedLabel: 'PDF',
  },
};

export const getFileExtension = (filename: string) => {
  const parts = filename.split('.');
  if (parts.length < 2) return '';
  return parts.pop()!.toLowerCase();
};

export const getNameFromFilename = (filename: string) => {
  const lastDot = filename.lastIndexOf('.');
  return lastDot > 0 ? filename.slice(0, lastDot) : filename;
};
